import React, { ReactElement } from "react";
import MainImg from "./mainImg";
import SharedButton from "../sharedButton";

export default function ComprehensiveSupport(): ReactElement {
    return (
        <section className=" flex flex-col lg:flex-row lg:gap-28 gap-16  lg:mt-28 mt-14 lg:mb-48 mb-20 ">
            <div className="max-w-[574px]  mx-auto lg:mx-0 order-2 ">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    Comprehensive Support & Inclusivity
                </h2>
                <p className="mt-5   lg:text-lg text-base lg:leading-8  font-light">
                    We connect you with extensive support services, including
                    travel arrangements, expense reimbursement, and follow-up
                    care. Our inclusive approach ensures that people from all
                    walks of life can participate, making our trials more
                    representative of the general population and improving the
                    reliability of the results.
                </p>
                <div className="lg:mt-[50px] mt-7 text-center sm:text-left">
                    <SharedButton />
                </div>
            </div>
            <div className="w-[250px] h-[250px] md:h-[372px] md:w-[448px] md:min-w-[448px] relative mx-auto  order-2 lg:mt-10">
                <MainImg />
            </div>
        </section>
    );
}
